import { PagingProps } from 'core/paging/paging.props';

export const PagingPresets: PagingProps = {
  color: 'black',
  currentPage: 0,
};
